import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconOldPhone: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"old-phone"} maskId="square-filled-radius-0-stroke-1-IconOldPhone"><path fillRule="evenodd" clipRule="evenodd" d="M5 1V3H20V17.5C20 19.9853 17.9853 22 15.5 22H8.5C6.01472 22 4 19.9853 4 17.5V1H5ZM8 7V13H16V7H8Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconOldPhone;
